<template>
  <b-modal
    id="search-options-modal"
    ref="search-options-modal"
    size="lg"
    centered
    title="Opções de pesquisa">
    <b-form-radio-group
      v-model="selectedOption"
      :options="options"
      class="mb-3"
      value-field="item"
      text-field="name"
      disabled-field="notEnabled"
    ></b-form-radio-group>
    <div v-if="selectedOption === 2">
      <hr>
      <div class="form-group row">
        <div class="col-md-12">
          <label for="agentId">Selecione um atendente:</label>
          <b-form-select
            type="text"
            id="agentId"
            ref="agentId"
            v-model="selectedAgentId"
            :options="agentOptions"
          />
        </div>
      </div>
    </div>
    <template #modal-footer>
      <div class="w-100 text-right">
        <button type="button" class="btn btn-success btn-sm" @click="onSetFilter" v-b-tooltip.hover title="Filtrar">
          <i class="fas fa-search mr-2"></i><span class="d-md-down-none">Filtrar</span>
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { loading } from '@/shared/utils/UIHelper'
// import AccountRepository from '@/shared/http/repositories/access/account.js'
import AccountMixin from '@/store/module/account/mixin'
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'

export default {
  name: 'SearchOptionsModal',
  mixins: [AccountMixin],
  data () {
    return {
      selectedOption: 0,
      options: [
        { item: 0, name: 'Minhas conversas', notEnabled: false },
        { item: 1, name: 'Conversas da equipe', notEnabled: false },
        { item: 2, name: 'Conversas por agente', notEnabled: false }
      ],
      agentOptions: [],
      selectedAgentId: null
    }
  },
  methods: {
    async open () {
      loading.push()
      try {
        await this.onLoadAllAgents()
        this.$refs['search-options-modal'].show()
      } catch (error) {
        console.error('Error opening search options modal:', error)
      } finally {
        loading.pop()
      }
    },
    close () {
      this.$refs['search-options-modal'].hide()
    },
    async onLoadAllAgents () {
      var requestConfig = {}
      if (this.account.administrador) {
        requestConfig = {
          permissions: [],
          paId: [],
          isAdm: this.account.administrador
        }
      } else {
        requestConfig = {
          permissions: this.account.permissoes,
          paId: this.account.funcionario.paId,
          isAdm: false
        }
      }
      try {
        const response = await AtendimentoRepository.GetUsenames(requestConfig)
        const { data } = response
        this.agentOptions = data.usernames.map(username => {
          return { text: username.nome, value: { username: username.username, nome: username.nome, id: username.id } }
        })
      } catch (error) {
        console.error(error)
      }
    },
    onSetFilter () {
      this.$emit('setFilter', {
        value: this.selectedOption,
        agentId: this.selectedOption === 2 ? this.selectedAgentId.id : null
      })
      this.close()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/conversations/modals/SearchOptionsModal.vue